export const normalizeVendorsForMessageSelection = (vendors = []) => {
  if (!Array.isArray(vendors) || vendors.length === 0) return [];

  return vendors
    .map((vendor) => {
      if (!vendor) return null;

      const token =
        vendor?.token ?? vendor?.vendor_token ?? vendor?.vendorToken ?? null;
      if (!token) return null;

      const company_name =
        vendor?.company_name ??
        vendor?.vendor_name ??
        vendor?.vendor ??
        vendor?.first_name ??
        vendor?.companyName ??
        "-";

      return {
        ...vendor,
        token,
        vendor_token: vendor?.vendor_token ?? vendor?.token,
        company_name,
      };
    })
    .filter(Boolean);
};

